import React, { Component } from "react";
import "./Modal.css";
import Aux from "../../../hoc/Aux/Aux";
import Backdrop from "../Backdrop/Backdrop";
import { prefix } from "../../../scripts/helpers/constants";

class Modal extends Component {
  render() {

    let open = prefix + "-c-modal " + prefix + "-c-modal-open";
    let close = prefix + "-c-modal " + prefix + "-c-modal-close";
    return (
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
        <div
          className={
            this.props.show
              ? open
              : close
          }
        >
          {this.props.children}
        </div>
      </Aux>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js